<template>
    <div class="col-md-12">
        <div class="panel panel-default">
            <div class="panel-heading">
                {{ translations.work_presences_of }} {{ user.first_name + ' ' + user.last_name  }}
            </div>
            <div class="panel-body">
                <template v-if="canSeeFullHistory">
                    <div class="tw-flex tw-gap-4">
                        <bordered-input>
                            <template #label>
                                <label for="from">
                                    Datum von
                                </label>
                            </template>
                            <template #input>
                                <input name="from" type="date" id="from" v-model="form.from">
                            </template>
                        </bordered-input>

                        <bordered-input>
                            <template #label>
                                <label for="to">
                                    Datum bis
                                </label>
                            </template>
                            <template #input>
                                <input name="to" type="date" id="to" v-model="form.to">
                            </template>
                        </bordered-input>

                        <button class="cu-btn" @click="fetchData">OK</button>
                        <a class="cu-btn" :href="this.dataEndpoint + `?from=${this.form.from}&to=${this.form.to}&action=download`" target="_blank">Download</a>
                    </div>
                </template>

                <div v-if="errorMessage" class="tw-w-full tw-bg-danger-primary tw-text-white tw-p-4 tw-flex tw-my-4 tw-rounded-lg">
                    {{ errorMessage }}
                </div>

                <table class="cu-table">
                    <thead>
                        <tr>
                            <th v-text="translations.label_work_date"></th>
                            <th v-text="translations.work_started"></th>
                            <th v-text="translations.work_ended"></th>
                            <th v-text="translations.work_present"></th>
                            <th v-text="translations.label_break"></th>
                            <th v-text="translations.work_time_worklog"></th>
                            <template v-if="isAdminView">
                                <th v-text="translations.ip_start"></th>
                                <th v-text="translations.ip_end"></th>
                            </template>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>

                        <template v-for="group in groupedRecords">
                            <tr class="tw-bg-slate-grey">
                                <td colspan="3">
                                    <div class="tw-py-2 tw-text-white tw-font-bold" v-text="'KW ' + group.calendar_week"></div>
                                </td>
                                <td colspan="6">
                                    <div
                                        class="tw-py-2 tw-text-white tw-font-bold"
                                        v-text="group.duration_sum"
                                    ></div>
                                </td>
                            </tr>

                            <tr v-for="record in group.items">
                                <td class="tw-whitespace-nowrap" v-text="record.date_formatted"></td>
                                <td v-text="!! record.work_start ? record.work_start : '-'"></td>
                                <td v-text="!! record.work_end ? record.work_end : '-'"></td>
                                <td v-text="!! record.duration ? record.duration : '-'"></td>

                                <td>
                                    <span
                                        class="tw-whitespace-nowrap"
                                        v-if="!! record.break"
                                        v-text="!! record.break ? (record.break + ' ' + translations.label_minutes) : '-'"
                                        :title="record.break_start + ' ' + record.break_end"
                                    ></span>
                                    <span v-else>-</span>
                                </td>

                                <td v-text="!! record.duration_tickets ? record.duration_tickets : '-'"></td>

                                <template v-if="isAdminView">
                                    <td v-text="!! record.ip_start ? record.ip_start : '-'"></td>
                                    <td v-text="!! record.ip_end ? record.ip_end : '-'"></td>
                                </template>

                                <td>
                                    <template v-if="record.exists">
                                        <template v-if="! record.has_change_request">
                                            <a v-if="canEdit"
                                               :href="record.edit_url"
                                               :title="translations.edit"
                                               class="cu-btn-sm"
                                            >
                                                <i class="fa fa-pencil"></i>
                                            </a>
                                        </template>

                                        <button
                                            v-else
                                            class="cu-btn-default-sm"
                                            v-text="translations.change_already_requested"
                                            disabled
                                        ></button>
                                    </template>
                                    <template v-else-if="!! record.create_url">
                                        <a class="cu-btn-default-sm"
                                           :href="record.create_url"
                                           v-text="translations.add_missing_workday_record"
                                        ></a>
                                    </template>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import BorderedInput from "../Redesign/BorderedInput.vue";

export default {
    components: {
        BorderedInput
    },

    props: {
        user: {
            type: Object,
            required: true,
        },

        isAdminView: {
            type: Boolean,
            required: true,
        },

        dataEndpoint: {
            type: String,
            required: true,
        },

        translations: {
            type: Object,
            required: true,
        },

        canEdit: {
            type: Boolean,
            required: true,
        },

        canSeeFullHistory: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            groupedRecords: [],
            form: {
                from: null,
                to: null,
            },
            errorMessage: null,
        }
    },

    methods: {
        fetchData() {
            this.errorMessage = null;

            axios
                .get(this.dataEndpoint + `?from=${this.form.from}&to=${this.form.to}`)
                .then(response => {
                    this.groupedRecords = response.data;
                })
                .catch(error => {
                    try {
                        this.errorMessage = error.response.data.message;
                    } catch (e) {
                        this.errorMessage = 'Es trat ein unerwarteter Fehler auf, bitte versuche es später erneut.';
                    }
                });
        }
    },

    mounted() {
        this.form.from = moment().subtract(1, 'week').startOf('isoWeek').format('YYYY-MM-DD');
        this.form.to = moment().format('YYYY-MM-DD');

        this.fetchData();
    }
}
</script>